// extracted by mini-css-extract-plugin
export var aircallIframe = "_es-3";
export var fabContainer = "_es-5";
export var fabRinging = "_es-6";
export var loadingOverlay = "_es-4";
export var pulse = "_es-7";
export var widgetContent = "_es-2";
export var widgetPanel = "_es-0";
export var widgetPanelExpanded = "_es-1";